async function poll(fn, validate, interval) {
    var newInterval = interval;

    const executePoll = async function (resolve, reject) {
        fn()
            .then(() => {
                newInterval = interval;

                // Se non passo la validazione
                if (!validate()) {
                    return resolve(0);
                }
                // Se è andato tutto bene
                else {
                    setTimeout(executePoll, newInterval, resolve, reject);
                }
            })
            .catch((err) => {
                console.log("Polling notification completed with errors: ", err);
                newInterval = newInterval * 3;
                console.log(`Polling timeout: ${newInterval / 3} => ${newInterval}`);
                setTimeout(executePoll, newInterval, resolve, reject);
            });
    };

    return new Promise(executePoll);
}

async function pollJwtToken(fn) {
    let newInterval;
    let requestSent = false;
    const timeout = (time) => new Promise((resolve) => setTimeout(resolve, time));
    const executePoll = async function (resolve, reject) {
        let tokenExpiration = parseInt(jwt_decode(LocalStorageManager.Read(LocalStorageRequests.JwtToken))["exp"]);
        let interval = tokenExpiration - Math.floor(new Date().getTime() / 1000);
        newInterval = interval * 1000 - 30 * 1000; //30 secondi prima della scadenza refresho il token
        if (requestSent && newInterval <= 1000) return;
        await timeout(newInterval);
        fn()
            .then(() => {
                requestSent = true;
                executePoll(resolve, reject);
            })
            .catch((err) => {
                console.log("pollJwtToken completed with errors: ", err);
                newInterval = newInterval * 3;
                console.log(`Polling timeout: ${newInterval / 3} => ${newInterval}`);
                executePoll(resolve, reject);
            });
    };

    return new Promise(executePoll);
}

function isNotificationsPollingEnabled() {
    return !store.state.application.tvMode;
}

import * as a from "./actions";
import * as a_options from "@/store/modules/OptionsModule/actions";
import * as a_notifications from "../NotificationsModule/actions";
import store from "@/store";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { RefreshTokenCommand, RefreshTokenReqData } from "@/model/communication/auth/RefreshTokenCommand";
import { RefreshTokenResData } from "@/model/communication/auth/RefreshTokenResData";
import jwt_decode from "jwt-decode";

export default {
    actions: {
        async [a.NOTIFICATIONS_POLLING]({ dispatch }, state) {
            // Funzione da ripetere ogni tot secondi
            async function func() {
                if (store.state.options.options.length > 0)
                    if (isNotificationsPollingEnabled()) {
                        // Se ho letto il timeout dalla configurazione .ini
                        // Se il polling notifiche è abilitato
                        var totalNotReadBefore = store.state.notifications.totalNotRead;

                        await dispatch(a_notifications.TOTAL_NOT_READ_NOTIFICATIONS); // Api Call

                        // Se ho nuove notifiche rifaccio il fetch
                        if (
                            store.state.notifications.totalNotRead != totalNotReadBefore &&
                            store.state.notifications.currentFilter != null &&
                            store.state.notifications.currentOptions != null
                        ) {
                            dispatch(a_notifications.FETCH_NOTIFICATIONS, {
                                filter: store.state.notifications.currentFilter,
                                options: store.state.notifications.currentOptions,
                            });
                        }
                    }
            }

            await dispatch(a_options.FETCH_OPTIONS);

            // console.log("notificationsPollingIntervalSec:", store.getters.notificationsPollingIntervalSec);
            if (isNotificationsPollingEnabled && store.getters.notificationsPollingIntervalSec >= 15) {
                poll(func, isNotificationsPollingEnabled, store.getters.notificationsPollingIntervalSec);
            }
        },

        async [a.JWT_REFRESH]({ dispatch }, state) {
            // Funzione da ripetere ogni tot secondi
            async function func() {
                let reqData: RefreshTokenReqData = new RefreshTokenReqData(LocalStorageManager.Read(LocalStorageRequests.JwtRefreshToken));
                let response: RefreshTokenResData = await new RefreshTokenCommand(reqData).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.token) {
                    LocalStorageManager.Write(LocalStorageRequests.JwtToken, response.token);
                }
            }

            pollJwtToken(func);
        },
    },
};
